import { lazy, useState } from "react";

import Suspense from "components/shared/Suspense";
import Avatar from "hardcover-ui/components/Avatar";
import classNames from "lib/classNames";
import pluralize from "lib/pluralize";
import LikeableType from "types/LikeableType";

const LikesModal = lazy(() => import("components/likes/LikesModal"));

export default function LoggedInItemLikes({
  showLikes,
  likeable,
  currentUserLiked,
  likesCount,
}: {
  showLikes: boolean;
  likeable: LikeableType;
  currentUserLiked: boolean;
  likesCount: number;
}) {
  const [showModal, setShowModal] = useState(false);

  if (likesCount === 0) {
    return false;
  }

  return (
    <div className="flex flex-row">
      <button
        type="button"
        className={classNames(
          "flex items-center gap-1 hover:underline text-sm font-semibold transition-all",
          currentUserLiked ? "text-red-500" : "",
        )}
        onClick={() => setShowModal(true)}
      >
        {likesCount.toLocaleString()} {pluralize("like", likesCount)}
        {showLikes && (
          <div className="flex flex-row -space-x-2 ml-2">
            {likeable.likes.map(activityLike => (
              <Avatar
                key={`like-${activityLike.user.id}-${activityLike.likeableId}-${activityLike.likeableType}`}
                image={activityLike.user.image}
                size="sm"
                alt={`@${activityLike.user.username}`}
              />
            ))}
          </div>
        )}{" "}
      </button>
      {showModal && (
        <Suspense>
          <LikesModal
            open={showModal}
            likeable={likeable}
            onClose={() => setShowModal(false)}
          />
        </Suspense>
      )}
    </div>
  );
}
